/**
 * RESPONSIBILITY: the sentence a field's description says, where more than one field says it.
 *
 * A hint written out at each of its twenty call sites is twenty hints, and they drift —
 * the same reason a colour is a token and not a hex code typed into every rule.
 */

/** The small line a band sets above its heading. Nine sections have one. */
export const ABOVE_HINT = 'The small line above the title.';

/** Every button target on the site. The `#` is the part editors get wrong. */
export const LINK_HINT = 'Where the button goes. A page on this site starts with # — e.g. #events.';

/** A band that shows rows of a list somebody else owns. */
export const COUNT_HINT = 'How many to show here. The list itself is edited in one place.';
